export default __webpack_public_path__ + "static/media/dynamic_value_editor_error.6a17449c.png";